import AppDispatcher from "../dispatcher/AppDispatcher"
import Constants from "../constants/Constants"
import 'whatwg-fetch'
import config from 'react-global-configuration';

var MailHistoryActions = {


  getList(token,accommdation_id){

    fetch(config.get("API_PATH") + config.get("API_ACCOMMODATION") + "/" + accommdation_id + config.get("API_MAIL") , {
      method: "GET",
      headers: {
          'Authorization': 'Bearer ' + token
      },
    }).then(function(response) {
      if(response.status === 200  ){
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
           return response.json()
         } else {
           return {"error":402}
        }
      }else if(response.status === 401){
        return null
      }else{
        return  {"error":response.status}
      }
    }).then(function(data) {

      if(data && !data.error){
        AppDispatcher.dispatch({
          actionType: Constants.MAIL_TEMPLATE_LIST_LOADED,
          list:data.items
        })
      }else{
        AppDispatcher.dispatch({
          actionType: Constants.API_ERROR,
          code:data.error
        })
      }
    })
  },

  setSelected(id){
    AppDispatcher.dispatch({
      actionType: Constants.MAIL_TEMPLATE_SELECTED,
      id:id
    })
  }

}

export default MailHistoryActions
